export default {
    name: 'customer',
    data: () => ({
        customers: []
    }),
    methods: {
        async getCustomers(search) {
            const result = this.$communicator.then(
                this,
                await this.$communicator("customers", {
                    arguments: [10, 1],
                    params: {
                        search: search
                    }
                })
            );

            if (result && result.data instanceof Array) {
                this.customers = result.data
            }

            return result;                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
        },
    }
}